import { render, staticRenderFns } from "./carta.vue?vue&type=template&id=e8fd983a&scoped=true"
import script from "./carta.vue?vue&type=script&lang=js"
export * from "./carta.vue?vue&type=script&lang=js"
import style0 from "./carta.vue?vue&type=style&index=0&id=e8fd983a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fd983a",
  null
  
)

export default component.exports